import styled from "@emotion/styled";

import ModalTemplate from "@/shared/components/templates/ModalTemplate/ModalTemplate";

const ResponsiveModalTemplate = styled(ModalTemplate)`
  max-height: calc(100vh - 48px);
  max-height: calc(100dvh - 48px);
  overflow-y: auto;
  overscroll-behavior: contain;

  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.65) transparent;
`;

const InputContainer = styled.div`
  margin-bottom: 15px;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1em;
  transition: all 0.3s ease-in-out;
`;

const FormContainer = styled.div`
  grid-column: span 2;
  display: contents;
`;

const StyledHr = styled.hr`
  height: 1px;
  border: none;
  background-color: rgba(224, 232, 255, 0.5);
  margin: 15px 0;
  width: 100%;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 20px;
  width: 100%;
`;

const SwitchContainer = styled.div`
  grid-template-columns: 1fr 1fr;
  gap: 1em;
  grid-column: span 2;
`;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  transition: height 0.3s ease;
`;

const SwitchMessage = styled.p`
  font-size: 12px;
`;

const SwitchTitle = styled.label`
  margin-right: 16px;
`;

const ModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 9;
  pointer-events: all;
`;

const CuitError = styled.span`
  color: #fafafa;
  font-weight: 600;
  margin-left: 8px;
`;

const ErrorContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  grid-column: span 2;
`;

const SignatureFieldContainer = styled.div`
  grid-column: span 2;
  width: 100%;
`;

export {
  ResponsiveModalTemplate,
  InputContainer,
  StyledHr,
  ButtonContainer,
  SwitchContainer,
  ModalContent,
  SwitchMessage,
  SwitchTitle,
  ModalBackdrop,
  CuitError,
  FormContainer,
  ErrorContainer,
  SignatureFieldContainer,
};
